var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCheckedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 47,
    viewBox: "0 0 57 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9993 43.8332C30.5354 43.8332 26.8035 43.8332 24.4848 41.5144C22.166 39.1957 22.166 35.4637 22.166 27.9998C22.166 20.5359 22.166 16.804 24.4848 14.4852C26.8035 12.1665 30.5354 12.1665 37.9993 12.1665C45.4633 12.1665 49.1952 12.1665 51.5139 14.4852C53.8327 16.804 53.8327 20.5359 53.8327 27.9998C53.8327 35.4637 53.8327 39.1957 51.5139 41.5144C49.1952 43.8332 45.4633 43.8332 37.9993 43.8332ZM44.3807 23.2018C44.8445 23.6656 44.8445 24.4174 44.3807 24.8812L36.464 32.7979C36.0003 33.2616 35.2484 33.2616 34.7847 32.7979L31.618 29.6312C31.1542 29.1674 31.1542 28.4156 31.618 27.9518C32.0817 27.4881 32.8336 27.4881 33.2974 27.9518L35.6243 30.2788L42.7013 23.2018C43.1651 22.7381 43.917 22.7381 44.3807 23.2018Z",
    fill: "#828282"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9993 34.8332C11.5354 34.8332 7.80349 34.8332 5.48475 32.5144C3.16602 30.1957 3.16602 26.4637 3.16602 18.9998C3.16602 11.5359 3.16602 7.80398 5.48475 5.48524C7.80349 3.1665 11.5354 3.1665 18.9993 3.1665C26.4633 3.1665 30.1952 3.1665 32.5139 5.48524C34.8327 7.80398 34.8327 11.5359 34.8327 18.9998C34.8327 26.4637 34.8327 30.1957 32.5139 32.5144C30.1952 34.8332 26.4633 34.8332 18.9993 34.8332ZM25.3807 14.2018C25.8445 14.6656 25.8445 15.4174 25.3807 15.8812L17.464 23.7979C17.0003 24.2616 16.2484 24.2616 15.7847 23.7979L12.618 20.6312C12.1542 20.1674 12.1542 19.4156 12.618 18.9518C13.0817 18.4881 13.8336 18.4881 14.2974 18.9518L16.6243 21.2788L23.7013 14.2018C24.1651 13.7381 24.917 13.7381 25.3807 14.2018Z",
    fill: "#A9A9AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckedGrey);
export default __webpack_public_path__ + "static/media/success-checked-grey.861d4f043044c67ccc212ffa278c8dbf.svg";
export { ForwardRef as ReactComponent };